module.exports = __webpack_public_path__ + "static/media/class_job_031.882d0a46.svg";